import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';

import { Observable } from 'rxjs';
import { Item, Blobs, BlobService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-item-single',
  templateUrl: './item-single.component.html',
  styleUrls: ['./item-single.component.scss']
})
export class ItemSingleComponent implements OnInit {
id: string;
item: Observable<Item>;
blob: Blobs;
  constructor(
    private db: AngularFirestore,
    private blobservice: BlobService,
    private route: ActivatedRoute) { }

  ngOnInit() {
this.id = this.route.snapshot.params.id;
this.item = this.db.collection('item').doc<Item>(this.id).valueChanges();
this.blobservice.get(this.id).subscribe(b => this.blob = b);
  }

}
